import { produce as applyImmutably } from 'immer';
import { AsyncStatus } from 'lib-shared-legacy-types';
import { handleActions } from 'redux-actions';

import { actions } from '../../actions/email';

export const {
  emailListAll,
  emailListAllSucceeded,
  emailListAllFailed,

  emailAdd,
  emailAddSucceeded,
  emailAddFailed,

  emailGet,
  emailGetSucceeded,
  emailGetFailed,

  emailDelete,
  emailDeleteSucceeded,
  emailDeleteFailed,

  emailUpdate,
  emailUpdateSucceeded,
  emailUpdateFailed,

  emailGetFlows,
  emailGetFlowsSucceeded,
  emailGetFlowsFailed,
} = actions;

export type EmailState = {
  organization_id: string | null;
  email_address: string | null;
  sender_name: string | null;
  spf_domain: string | null;
  spf_sender_email: string | null;
};

export type EmailStates = {
  emailList: Array<any>;
  currentEmail: EmailState;
  meta: {
    asyncStatus: AsyncStatus;
    getFlows: AsyncStatus;
    hasChanged: boolean;
    slug: string;
  };
  ui: {
    isEditModalOpen: boolean;
    isConfirmModalOpen: boolean;
  };
  flows: Array<any>;
};

const DEFAULT_EMAIL_SIGNATURE = `<p>
  Best regards,
</p>
<p>
  {{agent.display_name}<br />
  {{organization_name}}
</p>`;
function emptyEmail(): EmailState {
  return {
    organization_id: null,
    email_address: null,
    sender_name: null,
    spf_domain: null,
    spf_sender_email: null,
    signature_template: DEFAULT_EMAIL_SIGNATURE,
  } as any;
}

const initialState: EmailStates = {
  emailList: [],
  meta: {
    asyncStatus: 'succeeded',
    getFlows: 'succeeded',
    hasChanged: false,
    slug: '',
  },
  currentEmail: emptyEmail(),
  ui: {
    isEditModalOpen: false,
    isConfirmModalOpen: false,
  },
  flows: [],
};

// Reducer
export const email = handleActions<EmailStates, any>(
  {
    [emailListAll.toString()]: (state: EmailStates) => {
      return { ...state, meta: { ...state.meta, asyncStatus: 'loading' } };
    },

    [emailListAllSucceeded.toString()]: (state: EmailStates, action: any) => {
      const emailList = action.payload.data.slice();
      let currentEmail = Object.assign({}, state.currentEmail);

      const foundEmail = emailList.find(
        (e) => state.currentEmail.email_address === e.email_address,
      );

      if (foundEmail !== undefined) {
        currentEmail = foundEmail;
      }

      return {
        ...state,
        meta: { ...state.meta, asyncStatus: 'succeeded' },
        emailList: emailList,
        currentEmail: currentEmail,
      };
    },

    [emailListAllFailed.toString()]: (state: EmailStates) => {
      return { ...state, meta: { ...state.meta, asyncStatus: 'failed' } };
    },

    [emailAdd.toString()]: (state: EmailStates) => {
      return { ...state, meta: { ...state.meta, asyncStatus: 'loading' } };
    },

    [emailAddSucceeded.toString()]: (state: EmailStates, action: any) => {
      const removeUnwantedEmails = (email) =>
        email.email_address !== action.payload.data.email_address;

      return applyImmutably(state, (draftState: EmailStates) => {
        draftState.meta.asyncStatus = 'succeeded';
        draftState.ui.isEditModalOpen = false;
        draftState.emailList = [
          action.payload.data,
          ...state.emailList.filter(removeUnwantedEmails),
        ];
      });
    },

    [emailAddFailed.toString()]: (state: EmailStates) => {
      return { ...state, meta: { ...state.meta, asyncStatus: 'failed' } };
    },

    [emailGet.toString()]: (state: EmailStates) => {
      return { ...state, meta: { ...state.meta, asyncStatus: 'loading' } };
    },

    [emailGetSucceeded.toString()]: (state: EmailStates) => {
      return { ...state, meta: { ...state.meta, asyncStatus: 'succeeded' } };
    },

    [emailGetFailed.toString()]: (state: EmailStates) => {
      return { ...state, meta: { ...state.meta, asyncStatus: 'failed' } };
    },

    [emailDelete.toString()]: (state: EmailStates) => {
      return { ...state, meta: { ...state.meta, asyncStatus: 'loading' } };
    },

    [emailDeleteSucceeded.toString()]: (state: EmailStates, action: any) => {
      const emaillistCopy = state.emailList.slice();
      const emailList = emaillistCopy.filter(
        (x) => x.email_address !== action.payload.data.email_address,
      );

      return {
        ...state,
        meta: { ...state.meta, asyncStatus: 'succeeded' },
        ui: { ...state.ui, isConfirmModalOpen: false },
        currentEmail: emptyEmail(),
        emailList: emailList,
      };
    },

    [emailDeleteFailed.toString()]: (state: EmailStates) => {
      return { ...state, meta: { ...state.meta, asyncStatus: 'failed' } };
    },

    [emailGetFlows.toString()]: (state: EmailStates) => {
      return { ...state, meta: { ...state.meta, getFlows: 'loading' } };
    },

    [emailGetFlowsSucceeded.toString()]: (state: EmailStates, action: any) => {
      const flows =
        action.payload.data &&
        action.payload.data.conversation_flows &&
        Array.isArray(action.payload.data.conversation_flows) === true
          ? action.payload.data.conversation_flows
          : [];
      return {
        ...state,
        meta: { ...state.meta, getFlows: 'succeeded' },
        flows: flows,
      };
    },

    [emailGetFlowsFailed.toString()]: (state: EmailStates) => {
      return { ...state, meta: { ...state.meta, getFlows: 'failed' } };
    },

    [emailUpdate.toString()]: (state: EmailStates) => {
      return { ...state, meta: { ...state.meta, asyncStatus: 'loading' } };
    },

    [emailUpdateSucceeded.toString()]: (state: EmailStates, action: any) => {
      const index = state.emailList.findIndex((email: any) => {
        console.info(email, action.payload.data.email_address);
        return email.email_address === action.payload.data.email_address;
      });

      if (index > -1) {
        const emailList = state.emailList.slice();
        const email = Object.assign({}, state.emailList[index]);
        if (email !== undefined) {
          emailList[index] = Object.assign({}, action.payload.data);

          return {
            ...state,
            meta: { ...state.meta, asyncStatus: 'succeeded' },
            ui: { ...state.ui, isEditModalOpen: false },
            emailList: emailList,
          };
        }
        return {
          ...state,
          meta: { ...state.meta, asyncStatus: 'succeeded' },
          ui: { ...state.ui, isEditModalOpen: false },
        };
      }
      return {
        ...state,
        meta: { ...state.meta, asyncStatus: 'succeeded' },
        ui: { ...state.ui, isEditModalOpen: false },
      };
    },

    [emailUpdateFailed.toString()]: (state: EmailStates) => {
      return { ...state, meta: { ...state.meta, asyncStatus: 'failed' } };
    },
  },
  initialState,
);
